import { Immutable } from "immer";

import type { ImageChooserBlock, SealyLinkBlock } from "@reactivated";

/**
 * Reproduces the legacy ``{% image x original as image %}`` +
 * ``{{ image.url }}`` output: the original rendition's url, falling back to
 * the base image url if the rendition is somehow missing, or ``""`` when no
 * image is set (the Django tag's ``as`` var is then undefined and prints
 * empty).
 */
export const originalUrl = (
    image: Immutable<ImageChooserBlock> | null | undefined,
): string => (image ? (image.renditions["original"]?.url ?? image.url) : "");

/**
 * Replicates the legacy ``LinkValue.get_url``: the chosen page wins; if no
 * page is set, fall back to ``external_url``; otherwise ``""``.
 */
export const getLinkUrl = (
    link: Immutable<SealyLinkBlock> | null | undefined,
): string => link?.page?.url ?? link?.external_url ?? "";
